import React from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation, Link } from "react-router-dom";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import RawMaterial from "./components/Master/MenuMaster/RawMaterial";
import ServingMaster from "./components/Master/MenuMaster/ServingMaster";
import MSPC_BasicDetails from "./components/Master/MSPC_BasicDetails";
import CategoryMaster from "./components/Master/CategoryMaster";
import UploadSection from "./components/Master/UploadSection";
import RawMaterial_Planning from "./components/Master/RawMaterial_Planning";
import PM_Planning from "./components/Master/PM_Planning";
import RM_Calculation from "./components/Master/RM_Calculation";
import RM_Cal from "./components/Master/RM_Cal";
import RM_Table from "./components/Master/RM_Table";
import JobWork_PO from "./components/JobWork/JobWork_PO";
import JobWork_DC from "./components/JobWork/JobWork_DC";
import DetailScreen from "./components/Master/DetailScreen";
import PreviewScreen from "./components/Master/PreviewScreen";
import JW_PO from "./components/JobWork/JW_PO";
import JW_GenPO from "./components/JobWork/JW_GenPO";
import JW_DC from "./components/JobWork/JW_DC";
import JW_GenDC from "./components/JobWork/JW_GenDC";
import JW_TransportDC from "./components/JobWork/JW_TransportDC";
import JW_ReviewDC from "./components/JobWork/JW_ReviewDC";
import RM_TabS from "./components/Master/RM_TabS";
import { Breadcrumb } from "antd";
import FG_Approval from "./components/ApprovalScreens/FG_Approval";
import PO_Page from "./components/Master/Purchase/PO_Page";
import PO_PageTwo from "./components/Master/Purchase/PO_PageTwo";
import PO_MaterialTable from "./components/Master/Purchase/PO_MaterialTable";
import FG_App from "./components/ApprovalScreens/FG_App";
import FG_Report from "./components/ApprovalScreens/FG_Report";
import PM_Approval from "./components/ApprovalScreens/PM_Approval"
import PM_Report from "./components/ApprovalScreens/PM_Report";
import PM_App from "./components/ApprovalScreens/PM_App"


// Breadcrumb component
function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <Breadcrumb style={{ marginBottom: 16 }}>
       <Breadcrumb.Item>
        <Link to="/">Home</Link>
      </Breadcrumb.Item>
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const displayName = name.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
        const isLast = index === pathnames.length - 1;
        return (
          <Breadcrumb.Item key={routeTo}>
            {isLast ? displayName : <Link to={routeTo}>{displayName}</Link>}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
}

function LayoutWithSidebar() {
  return (
    <>
      {/* Navbar */}
      <div style={{ position: "fixed", top: 0, left: 0, right: 0, height: 40, zIndex: 1000 }}>
        <Navbar />
      </div>

      {/* Sidebar */}
      <div
        style={{
          position: "fixed",
          top: 60,
          left: 0,
          width: 200,
          height: "calc(100vh - 40px)",
          backgroundColor: "#012D51",
          overflowY: "auto",
          paddingTop: 20,
        }}
      >
        <Sidebar />
      </div>

      {/* Main Content */}
      <div
        style={{
          marginLeft: 200,
          padding: 20,
          paddingTop: 100,
          minHeight: "calc(100vh - 60px)",
          backgroundColor: "#F5F5F5",
        }}
      >
        {/* Breadcrumbs */}
        <Breadcrumbs />
        <Outlet />
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<LayoutWithSidebar />}>
        
          <Route path="/master/menu-master/raw-material" element={<RawMaterial />} />
          <Route path="/master/menu-master/serving-master" element={<ServingMaster />} />
          <Route path="/master/mspc_basicdetails" element={<MSPC_BasicDetails />} />
          <Route path="/master/category-master" element={<CategoryMaster />} />
          <Route path="/master/upload-section" element={<UploadSection />} />
          <Route path="/master/raw-material-planning" element={<RawMaterial_Planning />} />
          <Route path="/master/pm-planning" element={<PM_Planning />} />
          <Route path="/master/rm_calculation" element={<RM_Calculation />} />
          <Route path="/master/rm_cal" element={<RM_Cal />} />
          <Route path="/master/rm_table" element={<RM_Table />} />
          <Route path="/jobwork/jobwork_po" element={<JobWork_PO />} />
          <Route path="/jobwork/jobwork_dc" element={<JobWork_DC />} />
          <Route path="/master/raw-material-planning/details" element={<DetailScreen />} />
          <Route path="/master/raw-material-planning/preview" element={<PreviewScreen />} />
          <Route path="/jobwork/jobwork_po/jw_po" element={<JW_PO />} />
          <Route path="/jobwork/jobwork_po/jw_genpo" element={<JW_GenPO />} />
          <Route path="/jobwork/jobwork_dc/jw_dc" element={<JW_DC />} />
          <Route path="/jobwork/jobwork_dc/jw_transportdc" element={<JW_TransportDC />} />
          <Route path="/jobwork/jobwork_dc/jw_gendc" element={<JW_GenDC />} />
          <Route path="/jobwork/jobwork_dc/jw_reviewdc" element={<JW_ReviewDC />} />
          <Route path="/master/raw-material-planning/rm-table" element={<RM_Table />} />
          <Route path="/master/raw-material-planning/rm-tabs/:month" element={<RM_TabS />} />
          <Route path="/master/raw-material-planning/rm-calculation" element={<RM_Calculation />} />
          <Route path="/approvalscreens/fg-approval" element={<FG_Approval/>}></Route>
          <Route path="/master/purchase/po-page" element={<PO_Page/>}></Route>
          <Route path="/master/purchase/po-pageTwo" element={<PO_PageTwo />} />
          <Route path="/master/purchase/po-materialtable" element={<PO_MaterialTable />} />
          <Route path="/approvalscreens/fg-app" element={<FG_App/>}/>
          <Route path="/approvalscreens/fg-report" element={<FG_Report/>}/>
          <Route path="/approvalscreens/pm-approval" element={<PM_Approval/>}/>
          <Route path="/approvalscreens/pm-app" element={<PM_App/>}/>
          <Route path="/approvalscreens/pm-report" element={<PM_Report/>}/>

        </Route>
      </Routes>
    </Router>
  );
}

export default App;
